import React from 'react';
import PropTypes from 'prop-types';
import { Embed } from 'semantic-ui-react';

export default class Map extends React.Component {
  getFormattedAddress() {
    const { street, locality, country } = this.createAddressComponents();

    return `${street}, ${locality} ${country}`;
  }

  createAddressComponents() {
    const { address } = this.props;
    const { street, city, state, zip, country } = address;

    const locality = `${city}, ${state} ${zip}`;

    return { street, locality, country };
  }

  createMapLink() {
    const { businessName } = this.props;
    const formattedAddress = this.getFormattedAddress();

    // Link constants
    const embedBase = 'https://maps.google.com/maps?q=';
    const embedTail = '&t=&z=13&ie=UTF8&iwloc=&output=embed';

    // Address query
    const query = encodeURIComponent(
      businessName ? `${businessName} ${formattedAddress}` : formattedAddress,
    );

    return `${embedBase}${query}${embedTail}`;
  }

  render() {
    return <Embed url={this.createMapLink()} active className="map" />;
  }
}

Map.propTypes = {
  address: PropTypes.shape({
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
    country: PropTypes.string,
    street: PropTypes.string,
  }).isRequired,
  businessName: PropTypes.string,
};

Map.defaultProps = {
  businessName: '',
};
